import { apiSdkAssetsPublicMocks } from '@ingenico/api-sdk-assets-public/mocks';
import type { ApiSdkMocksControl } from '@ingenico/api-sdk-core/common';
import { ApiSdkMockDeclaration, initializeMocks } from '@ingenico/api-sdk-core/mocks';
import {
  createArtifactV2,
  createArtifactV2RelativeUrl,
  createApplicationVersionV2,
  createApplicationVersionV2RelativeUrl,
  createResourceV2,
  createResourceV2RelativeUrl,
  createCatalogShareV2,
  createCatalogShareV2RelativeUrl,
  createTemplateV2,
  createTemplateV2RelativeUrl,
  deleteConfigurationModuleByIdV2,
  deleteConfigurationModuleByIdV2RelativeUrl,
  downloadOutputFileForTemplateV2,
  downloadOutputFileForTemplateV2RelativeUrl,
  downloadOutputFileV2,
  downloadOutputFileV2RelativeUrl,
  getAllOsVersionArtifactsByOsVersionIdV2,
  getAllOsVersionArtifactsByOsVersionIdV2RelativeUrl,
  getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2,
  getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2RelativeUrl,
  getApplicationByIdV2,
  GetApplicationByIdV2QueryResponseApi,
  getApplicationByIdV2RelativeUrl,
  getApplicationTemplatesByApplicationIdV2,
  getApplicationTemplatesByApplicationIdV2RelativeUrl,
  getApplicationVersionArtifactByApplicationVersionIdV2,
  getApplicationVersionArtifactByApplicationVersionIdV2RelativeUrl,
  getApplicationVersionTemplatesByApplicationVersionIdV2,
  getApplicationVersionTemplatesByApplicationVersionIdV2RelativeUrl,
  getArtifactCapabilitiesV2,
  getArtifactCapabilitiesV2RelativeUrl,
  getBffApplicationVersionByIdV2,
  getBffApplicationVersionByIdV2RelativeUrl,
  getBffSystemPackageVersionByIdV2,
  getBffSystemPackageVersionByIdV2RelativeUrl,
  getCatalogShareByIdBffV2,
  getCatalogShareByIdBffV2RelativeUrl,
  getConfigurationByIdBffV2,
  getConfigurationByIdBffV2RelativeUrl,
  getConfigurationModuleByIdBffV2,
  getConfigurationModuleByIdBffV2RelativeUrl,
  getComputedConfigurationModuleSnapshotByIdBffV2,
  getComputedConfigurationModuleSnapshotByIdBffV2RelativeUrl,
  getComputedParameterSetSnapshotByIdBffV2,
  getComputedParameterSetSnapshotByIdBffV2RelativeUrl,
  getConfigurationModuleSnapshotByIdBffV2,
  getConfigurationModuleSnapshotByIdBffV2RelativeUrl,
  getConfigurationSnapshotByIdBffV2,
  getConfigurationSnapshotByIdBffV2RelativeUrl,
  getDeployedComputedConfigurationByDeviceIdBffV2,
  getDeployedComputedConfigurationByDeviceIdBffV2RelativeUrl,
  getDeploymentRequestByIdBffV2,
  getDeploymentRequestByIdBffV2RelativeUrl,
  getDeploymentUnitByIdBffV2,
  getDeploymentUnitByIdBffV2RelativeUrl,
  getOutputFilenamesForDeploymentUnitBffV2,
  getOutputFilenamesForDeploymentUnitBffV2RelativeUrl,
  searchOutputFilesBffV2,
  searchOutputFilesBffV2RelativeUrl,
  getKeySetReferenceV2,
  getKeySetReferenceV2RelativeUrl,
  getOsByIdV2,
  getOsByIdV2RelativeUrl,
  getResourceDownloadLinkV2,
  getResourceDownloadLinkV2RelativeUrl,
  getResourceSearchFieldValuesV2,
  getResourceSearchFieldValuesV2RelativeUrl,
  getRkiConfigurationByOrganizationIdV2,
  getRkiConfigurationByOrganizationIdV2RelativeUrl,
  getSystemPackageTemplatesBySystemPackageIdV2,
  getSystemPackageTemplatesBySystemPackageIdV2RelativeUrl,
  getSystemPackageVersionTemplatesBySystemPackageVersionIdV2,
  getSystemPackageVersionTemplatesBySystemPackageVersionIdV2RelativeUrl,
  getTemplateByIdV2,
  getTemplateByIdV2RelativeUrl,
  ResourceDataFileResourceReadApi,
  searchApplicationsV2,
  searchApplicationsV2RelativeUrl,
  searchApplicationVersionsV2,
  searchApplicationVersionsV2RelativeUrl,
  searchBffResourcesV2,
  searchBffResourcesV2RelativeUrl,
  searchCatalogSharesBffV2,
  searchCatalogSharesBffV2RelativeUrl,
  searchDeploymentUnitsBffV2,
  searchDeploymentUnitsBffV2RelativeUrl,
  searchOsV2,
  searchOsV2RelativeUrl,
  searchOsVersionsV2,
  searchOsVersionsV2RelativeUrl,
  searchResourcesV2,
  searchResourcesV2RelativeUrl,
  searchSystemPackagesV2,
  searchSystemPackagesV2RelativeUrl,
  searchSystemPackageVersionsV2,
  searchSystemPackageVersionsV2RelativeUrl,
  triggerCatalogShareRevokeV2,
  triggerCatalogShareRevokeV2RelativeUrl,
  updateApplicationVersionByIdV2,
  updateApplicationVersionByIdV2RelativeUrl,
  type ApplicationVersionResourceListResponseV2Api,
  type ApplicationVersionResourceReadV2Api,
  type BffSystemPackageVersionResourceReadV2Api,
  type CatalogShareResourceListResponseBffApi,
  type CatalogShareResourceReadApi,
  type CatalogShareResourceReadBffApi,
  type ConfigurationResourceReadBffV2Api,
  type CreateArtifactV2MutationResponseApi,
  type CreateResourceV2MutationResponseApi,
  type DeploymentRequestResourceItemBffV2Api,
  type DeploymentUnitResourceListResponseBffV2Api,
  type DownloadOutputFileForTemplateV2QueryResponseApi,
  type DownloadOutputFileV2QueryResponseApi,
  type GetAllOsVersionArtifactsByOsVersionIdV2QueryResponseApi,
  type GetArtifactCapabilitiesV2QueryResponseApi,
  type GetAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2QueryResponseApi,
  type GetApplicationVersionArtifactByApplicationVersionIdV2QueryResponseApi,
  type GetApplicationVersionTemplatesByApplicationVersionIdV2QueryResponseApi,
  type GetBffApplicationVersionByIdV2QueryResponseApi,
  type GetConfigurationByIdBffV2QueryResponseApi,
  type GetConfigurationModuleByIdBffV2QueryResponseApi,
  type GetComputedConfigurationModuleSnapshotByIdBffV2QueryResponseApi,
  type GetComputedParameterSetSnapshotByIdBffV2QueryResponseApi,
  type GetConfigurationModuleSnapshotByIdBffV2QueryResponseApi,
  type GetDeployedComputedConfigurationByDeviceIdBffV2QueryResponseApi,
  type GetDeploymentUnitByIdBffV2QueryResponseApi,
  type GetOutputFilenamesForDeploymentUnitBffV2QueryResponseApi,
  type SearchOutputFilesBffV2MutationResponseApi,
  type GetKeySetReferenceV2QueryResponseApi,
  type GetOsByIdV2QueryResponseApi,
  type GetRkiConfigurationByOrganizationIdV2QueryResponseApi,
  type GetSystemPackageTemplatesBySystemPackageIdV2QueryResponseApi,
  type GetSystemPackageVersionTemplatesBySystemPackageVersionIdV2QueryResponseApi,
  type OsResourceListResponseV2Api,
  type DownloadLinkResourceApi,
  type OsVersionResourceListResponseV2Api,
  type ResourceDataFileResourceListResponseApi,
  type ResourceDataFileResourceListResponseBffApi,
  type SearchApplicationsV2MutationResponseApi,
  type SearchSystemPackagesV2MutationResponseApi,
  type SystemPackageVersionResourceListResponseV2Api,
  type TemplateDetailedResourceReadV2Api,
  type TemplateResourceListResponseV2Api,
  type TemplateResourceReadV2Api,
  updateResourceByIdV2RelativeUrl,
  updateResourceByIdV2,
} from '@ingenico/api-sdk-device-management-private-v2';
import { apiSdkDeviceManagementPrivateV2Mocks } from '@ingenico/api-sdk-device-management-private-v2/mocks';
import { apiSdkDeviceManagementPrivateMocks } from '@ingenico/api-sdk-device-management-private/mocks';

import {
  searchSmartFieldsBffV1,
  searchSmartFieldsBffV1RelativeUrl,
  type SmartFieldResourceListBffResponseApi,
} from '@ingenico/api-sdk-configuration-private';
import { apiSdkConfigurationPrivateMocks } from '@ingenico/api-sdk-configuration-private/mocks';
import { apiSdkConfigurationPublicMocks } from '@ingenico/api-sdk-configuration-public/mocks';
import { apiSdkDeviceManagementPublicMocks } from '@ingenico/api-sdk-device-management-public/mocks';
import {
  CurrentUserResourceApi,
  getCurrentUserV1,
  getCurrentUserV1RelativeUrl,
} from '@ingenico/api-sdk-directory-private';
import { apiSdkDirectoryPrivateMocks } from '@ingenico/api-sdk-directory-private/mocks';
import {
  getBffLogicalDeviceByIdV1,
  getBffLogicalDeviceByIdV1RelativeUrl,
  type GetBffLogicalDeviceByIdV1QueryResponseApi,
} from '@ingenico/api-sdk-provisioning-private';
import { apiSdkProvisioningPrivateMocks } from '@ingenico/api-sdk-provisioning-private/mocks';
import { apiSdkProvisioningPublicMocks } from '@ingenico/api-sdk-provisioning-public/mocks';
import {
  searchSubscriptionsDetailsV1,
  searchSubscriptionsDetailsV1RelativeUrl,
  type SubscriptionResourceDetailsListResponseApi,
} from '@ingenico/api-sdk-subscription-private';
import { apiSdkSubscriptionPrivateMocks } from '@ingenico/api-sdk-subscription-private/mocks';
import { HttpResponse } from 'msw';
import { generateDeploymentRequestResourceItemBffV2 } from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  getCatalogShareByIdV2ResponseMock,
  triggerCatalogShareRevokeV2ResponseMock,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  createApplicationVersionV2CustomHandler,
  getApplicationVersionArtifactByApplicationVersionIdV2ResponseMock,
  searchApplicationVersionsV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  getApplicationByIdV2ResponseMock,
  getApplicationTemplatesByApplicationIdV2ResponseMock,
  searchApplicationsV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  deleteConfigurationModuleByIdV2CustomHandler,
  downloadOutputFileForTemplateV2CustomHandler,
  downloadOutputFileV2CustomHandler,
  getBffApplicationVersionByIdV2InitialData,
  getBffConfigurationByIdV2InitialData,
  getConfigurationModuleByIdBffV2CustomHandlerForDetailsPage,
  getSpecificTemplateIdsConfigurationModuleSnapshotByIdBffV2ResponseMock,
  getConfigurationSnapshotByIdBffV2ResponseMock,
  getDeployedComputedConfigurationByDeviceIdBffV2ResponseMock,
  getDeploymentUnitByIdBffV2ResponseMock,
  getOutputFilenamesForDeploymentUnitBffV2ResponseMock,
  searchOutputFilesBffV2ResponseMock,
  putApplicationVersionByIdV2Handler,
  searchDeploymentUnitsBffV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  createCatalogShareV2CustomHandler,
  searchCatalogSharesBffV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local/payloads/catalog-shares';
import {
  getComputedConfigurationModuleSnapshotByIdBffV2CustomHandler,
  getComputedParameterSetSnapshotByIdBffV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local/payloads/computed-snapshots';
import { getKeySetReferenceV2ResponseMock } from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import { getRkiConfigurationByOrganizationIdV2ResponseMock } from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  getAllOsVersionArtifactsByOsVersionIdV2ResponseMock,
  getOsByIdV2ResponseMock,
  searchOsV2CustomHandler,
  searchOsVersionCustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  getResourceDownloadLinkV2CustomHandler,
  createArtifactV2CustomHandler,
  createResourceV2CustomHandler,
  getArtifactCapabilitiesV2CustomHandler,
  getResourceSearchFieldValuesV2CustomHandler,
  searchResourcesV2CustomHandler,
  searchBffResourcesV2CustomHandler,
  updateResourceByIdV2Mock,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  getSystemPackageTemplatesBySystemPackageIdV2InitialData,
  searchSystemPackagesV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2ResponseMock,
  getBffSystemPackageVersionByIdV2ResponseMock,
  initialGetSystemPackageVersionTemplatesByApplicationIdCustomHandler,
  searchSystemPackageVersionsV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import {
  createTemplateV2MockedResponse,
  getTemplateByIdV2CustomHandler,
} from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import { getApplicationVersionTemplatesByApplicationIdCustomHandler } from '../mocks/local-sdk-stubs/device-management-private-v2-local';
import { getCurrentUserV1Handler } from '../mocks/local-sdk-stubs/directory-private-local/directory-private-local';
import {
  searchLogicalDevicesV1,
  searchLogicalDevicesV1RelativeUrl,
  type LogicalDeviceListResponseApi,
} from '@ingenico/api-sdk-provisioning-public';
import { getBffLogicalDeviceByIdV1CustomHandler } from '../mocks/local-sdk-stubs/provisioning-private-local';
import { searchLogicalDevicesV1Handler } from '../mocks/local-sdk-stubs/provisioning-public-local';

function searchSubscriptionsDetailsV1Handler() {
  return HttpResponse.json({
    pagination: { totalResults: 0, startIndex: 0, itemsPerPage: 1 },
    data: [],
  } satisfies SubscriptionResourceDetailsListResponseApi);
}

function searchSmartFieldsBffV1Handler() {
  return HttpResponse.json({
    pagination: { totalResults: 2, startIndex: 0, itemsPerPage: 10 },
    data: [
      {
        id: '53cb5f38-f301-490c-9d3b-c3211d7ebee2',
        name: 'Existing string smart field',
        description: 'Reusable string smart field for standalone module testing',
        dataType: 'STRING',
        defaultValue: 'Existing value',
        createdBy: {
          id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
          name: 'John Doe',
        },
        updatedBy: {
          id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
          name: 'John Doe',
        },
        creationDate: new Date('2025-01-01T00:00:00Z'),
        updateDate: new Date('2025-01-02T00:00:00Z'),
        uiComponent: {
          type: 'INPUT',
          options: {
            inputString: {
              defaultValue: 'Existing value',
              label: 'Existing string smart field',
              placeholder: 'Existing value',
              type: 'TEXT',
            },
          },
        },
        categories: [],
      },
      {
        id: '1de1142e-fd54-47b5-88bb-0a057bc77650',
        name: 'Secondary string smart field',
        description: 'Another reusable string smart field',
        dataType: 'STRING',
        defaultValue: 'Secondary value',
        createdBy: {
          id: 'd0e8e8e0-1b4d-4336-99b8-548e08b05801',
          name: 'Jane Doe',
        },
        creationDate: new Date('2025-01-03T00:00:00Z'),
        uiComponent: {
          type: 'INPUT',
          options: {
            inputString: {
              defaultValue: 'Secondary value',
              label: 'Secondary string smart field',
              placeholder: 'Secondary value',
              type: 'TEXT',
            },
          },
        },
        categories: [],
      },
    ],
  } satisfies SmartFieldResourceListBffResponseApi);
}

export async function appMocksInit(apiOrigin: string): Promise<ApiSdkMocksControl> {
  return initializeMocks({
    baseUrl: apiOrigin,
    enableMockByDefault: true,
    globalDelay: 1500,
    mocksDeclarations: [
      apiSdkAssetsPublicMocks,
      apiSdkConfigurationPrivateMocks,
      apiSdkConfigurationPublicMocks,
      apiSdkDeviceManagementPrivateMocks,
      apiSdkDeviceManagementPrivateV2Mocks,
      apiSdkDeviceManagementPublicMocks,
      apiSdkDirectoryPrivateMocks,
      apiSdkProvisioningPrivateMocks,
      apiSdkProvisioningPublicMocks,
      apiSdkSubscriptionPrivateMocks,
    ],
    // Override example
    mocksDeclarationOverrides: {
      [searchCatalogSharesBffV2.name]: {
        relativeUrl: searchCatalogSharesBffV2RelativeUrl,
        customHandler: searchCatalogSharesBffV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<CatalogShareResourceListResponseBffApi>,
      [createCatalogShareV2.name]: {
        relativeUrl: createCatalogShareV2RelativeUrl,
        customHandler: createCatalogShareV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<CatalogShareResourceReadApi>,
      [getCurrentUserV1.name]: {
        relativeUrl: getCurrentUserV1RelativeUrl,
        customHandler: getCurrentUserV1Handler,
      } satisfies ApiSdkMockDeclaration<CurrentUserResourceApi>,
      [searchSubscriptionsDetailsV1.name]: {
        relativeUrl: searchSubscriptionsDetailsV1RelativeUrl,
        customHandler: searchSubscriptionsDetailsV1Handler,
      } satisfies ApiSdkMockDeclaration<SubscriptionResourceDetailsListResponseApi>,
      [searchSmartFieldsBffV1.name]: {
        relativeUrl: searchSmartFieldsBffV1RelativeUrl,
        customHandler: searchSmartFieldsBffV1Handler,
      } satisfies ApiSdkMockDeclaration<SmartFieldResourceListBffResponseApi>,
      [searchLogicalDevicesV1.name]: {
        relativeUrl: searchLogicalDevicesV1RelativeUrl,
        customHandler: searchLogicalDevicesV1Handler,
      } satisfies ApiSdkMockDeclaration<LogicalDeviceListResponseApi>,
      [getBffLogicalDeviceByIdV1.name]: {
        relativeUrl: getBffLogicalDeviceByIdV1RelativeUrl,
        customHandler: getBffLogicalDeviceByIdV1CustomHandler,
      } satisfies ApiSdkMockDeclaration<GetBffLogicalDeviceByIdV1QueryResponseApi>,
      // Applications
      [getApplicationByIdV2.name]: {
        relativeUrl: getApplicationByIdV2RelativeUrl,
        initialDataFactory: getApplicationByIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetApplicationByIdV2QueryResponseApi>,
      [searchApplicationsV2.name]: {
        relativeUrl: searchApplicationsV2RelativeUrl,
        customHandler: searchApplicationsV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<SearchApplicationsV2MutationResponseApi>,
      [getApplicationTemplatesByApplicationIdV2.name]: {
        relativeUrl: getApplicationTemplatesByApplicationIdV2RelativeUrl,
        initialDataFactory: getApplicationTemplatesByApplicationIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<TemplateResourceListResponseV2Api>,
      // Application Versions
      [createApplicationVersionV2.name]: {
        relativeUrl: createApplicationVersionV2RelativeUrl,
        customHandler: createApplicationVersionV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<ApplicationVersionResourceReadV2Api>,
      [createArtifactV2.name]: {
        relativeUrl: createArtifactV2RelativeUrl,
        customHandler: createArtifactV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<CreateArtifactV2MutationResponseApi>,
      [createResourceV2.name]: {
        relativeUrl: createResourceV2RelativeUrl,
        customHandler: createResourceV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<CreateResourceV2MutationResponseApi>,
      [getApplicationVersionArtifactByApplicationVersionIdV2.name]: {
        relativeUrl: getApplicationVersionArtifactByApplicationVersionIdV2RelativeUrl,
        initialDataFactory: getApplicationVersionArtifactByApplicationVersionIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetApplicationVersionArtifactByApplicationVersionIdV2QueryResponseApi>,
      [searchApplicationVersionsV2.name]: {
        relativeUrl: searchApplicationVersionsV2RelativeUrl,
        customHandler: searchApplicationVersionsV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<ApplicationVersionResourceListResponseV2Api>,
      [getBffApplicationVersionByIdV2.name]: {
        relativeUrl: getBffApplicationVersionByIdV2RelativeUrl,
        initialDataFactory: getBffApplicationVersionByIdV2InitialData,
      } satisfies ApiSdkMockDeclaration<GetBffApplicationVersionByIdV2QueryResponseApi>,
      [updateApplicationVersionByIdV2.name]: {
        relativeUrl: updateApplicationVersionByIdV2RelativeUrl,
        customHandler: putApplicationVersionByIdV2Handler,
      } satisfies ApiSdkMockDeclaration<ApplicationVersionResourceReadV2Api>,
      [getApplicationVersionTemplatesByApplicationVersionIdV2.name]: {
        relativeUrl: getApplicationVersionTemplatesByApplicationVersionIdV2RelativeUrl,
        customHandler: getApplicationVersionTemplatesByApplicationIdCustomHandler,
      } satisfies ApiSdkMockDeclaration<GetApplicationVersionTemplatesByApplicationVersionIdV2QueryResponseApi>,
      // OS
      [searchOsV2.name]: {
        relativeUrl: searchOsV2RelativeUrl,
        customHandler: searchOsV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<OsResourceListResponseV2Api>,
      [getOsByIdV2.name]: {
        relativeUrl: getOsByIdV2RelativeUrl,
        initialDataFactory: getOsByIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetOsByIdV2QueryResponseApi>,
      [searchOsVersionsV2.name]: {
        relativeUrl: searchOsVersionsV2RelativeUrl,
        customHandler: searchOsVersionCustomHandler,
      } satisfies ApiSdkMockDeclaration<OsVersionResourceListResponseV2Api>,
      [searchResourcesV2.name]: {
        relativeUrl: searchResourcesV2RelativeUrl,
        customHandler: searchResourcesV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<ResourceDataFileResourceListResponseApi>,
      [searchBffResourcesV2.name]: {
        relativeUrl: searchBffResourcesV2RelativeUrl,
        customHandler: searchBffResourcesV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<ResourceDataFileResourceListResponseBffApi>,
      [getResourceDownloadLinkV2.name]: {
        relativeUrl: getResourceDownloadLinkV2RelativeUrl,
        customHandler: getResourceDownloadLinkV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<DownloadLinkResourceApi>,
      [getArtifactCapabilitiesV2.name]: {
        relativeUrl: getArtifactCapabilitiesV2RelativeUrl,
        customHandler: getArtifactCapabilitiesV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<GetArtifactCapabilitiesV2QueryResponseApi>,
      [getResourceSearchFieldValuesV2.name]: {
        relativeUrl: getResourceSearchFieldValuesV2RelativeUrl,
        customHandler: getResourceSearchFieldValuesV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<string[]>,
      [getAllOsVersionArtifactsByOsVersionIdV2.name]: {
        relativeUrl: getAllOsVersionArtifactsByOsVersionIdV2RelativeUrl,
        initialDataFactory: getAllOsVersionArtifactsByOsVersionIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetAllOsVersionArtifactsByOsVersionIdV2QueryResponseApi>,
      // System Packages
      [searchSystemPackagesV2.name]: {
        relativeUrl: searchSystemPackagesV2RelativeUrl,
        customHandler: searchSystemPackagesV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<SearchSystemPackagesV2MutationResponseApi>,
      [getSystemPackageTemplatesBySystemPackageIdV2.name]: {
        relativeUrl: getSystemPackageTemplatesBySystemPackageIdV2RelativeUrl,
        initialDataFactory: getSystemPackageTemplatesBySystemPackageIdV2InitialData,
      } satisfies ApiSdkMockDeclaration<GetSystemPackageTemplatesBySystemPackageIdV2QueryResponseApi>,
      // System Package Versions
      [getBffSystemPackageVersionByIdV2.name]: {
        relativeUrl: getBffSystemPackageVersionByIdV2RelativeUrl,
        initialDataFactory: getBffSystemPackageVersionByIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<BffSystemPackageVersionResourceReadV2Api>,
      [searchSystemPackageVersionsV2.name]: {
        relativeUrl: searchSystemPackageVersionsV2RelativeUrl,
        customHandler: searchSystemPackageVersionsV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<SystemPackageVersionResourceListResponseV2Api>,
      [getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2.name]: {
        relativeUrl: getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2RelativeUrl,
        initialDataFactory: getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2QueryResponseApi>,
      [getSystemPackageVersionTemplatesBySystemPackageVersionIdV2.name]: {
        relativeUrl: getSystemPackageVersionTemplatesBySystemPackageVersionIdV2RelativeUrl,
        initialDataFactory: initialGetSystemPackageVersionTemplatesByApplicationIdCustomHandler,
      } satisfies ApiSdkMockDeclaration<GetSystemPackageVersionTemplatesBySystemPackageVersionIdV2QueryResponseApi>,
      // Templates
      [getTemplateByIdV2.name]: {
        relativeUrl: getTemplateByIdV2RelativeUrl,
        customHandler: getTemplateByIdV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<TemplateDetailedResourceReadV2Api>,
      [createTemplateV2.name]: {
        relativeUrl: createTemplateV2RelativeUrl,
        customHandler: createTemplateV2MockedResponse,
      } satisfies ApiSdkMockDeclaration<TemplateResourceReadV2Api>,
      // Configuration (BFF)
      [getConfigurationByIdBffV2.name]: {
        relativeUrl: getConfigurationByIdBffV2RelativeUrl,
        initialDataFactory: getBffConfigurationByIdV2InitialData,
      } satisfies ApiSdkMockDeclaration<GetConfigurationByIdBffV2QueryResponseApi>,
      [getConfigurationSnapshotByIdBffV2.name]: {
        relativeUrl: getConfigurationSnapshotByIdBffV2RelativeUrl,
        initialDataFactory: getConfigurationSnapshotByIdBffV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<ConfigurationResourceReadBffV2Api>,
      [getConfigurationModuleByIdBffV2.name]: {
        relativeUrl: getConfigurationModuleByIdBffV2RelativeUrl,
        customHandler: getConfigurationModuleByIdBffV2CustomHandlerForDetailsPage,
      } satisfies ApiSdkMockDeclaration<GetConfigurationModuleByIdBffV2QueryResponseApi>,
      [getConfigurationModuleSnapshotByIdBffV2.name]: {
        relativeUrl: getConfigurationModuleSnapshotByIdBffV2RelativeUrl,
        initialDataFactory: getSpecificTemplateIdsConfigurationModuleSnapshotByIdBffV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetConfigurationModuleSnapshotByIdBffV2QueryResponseApi>,
      [getComputedConfigurationModuleSnapshotByIdBffV2.name]: {
        relativeUrl: getComputedConfigurationModuleSnapshotByIdBffV2RelativeUrl,
        customHandler: getComputedConfigurationModuleSnapshotByIdBffV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<GetComputedConfigurationModuleSnapshotByIdBffV2QueryResponseApi>,
      [getComputedParameterSetSnapshotByIdBffV2.name]: {
        relativeUrl: getComputedParameterSetSnapshotByIdBffV2RelativeUrl,
        customHandler: getComputedParameterSetSnapshotByIdBffV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<GetComputedParameterSetSnapshotByIdBffV2QueryResponseApi>,
      [deleteConfigurationModuleByIdV2.name]: {
        relativeUrl: deleteConfigurationModuleByIdV2RelativeUrl,
        customHandler: deleteConfigurationModuleByIdV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<unknown>,
      // Deployment (BFF)
      [getDeployedComputedConfigurationByDeviceIdBffV2.name]: {
        relativeUrl: getDeployedComputedConfigurationByDeviceIdBffV2RelativeUrl,
        initialDataFactory: getDeployedComputedConfigurationByDeviceIdBffV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetDeployedComputedConfigurationByDeviceIdBffV2QueryResponseApi>,
      [searchDeploymentUnitsBffV2.name]: {
        relativeUrl: searchDeploymentUnitsBffV2RelativeUrl,
        customHandler: searchDeploymentUnitsBffV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<DeploymentUnitResourceListResponseBffV2Api>,
      [getDeploymentUnitByIdBffV2.name]: {
        relativeUrl: getDeploymentUnitByIdBffV2RelativeUrl,
        initialDataFactory: getDeploymentUnitByIdBffV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetDeploymentUnitByIdBffV2QueryResponseApi>,
      [getOutputFilenamesForDeploymentUnitBffV2.name]: {
        relativeUrl: getOutputFilenamesForDeploymentUnitBffV2RelativeUrl,
        initialDataFactory: getOutputFilenamesForDeploymentUnitBffV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetOutputFilenamesForDeploymentUnitBffV2QueryResponseApi>,
      [searchOutputFilesBffV2.name]: {
        relativeUrl: searchOutputFilesBffV2RelativeUrl,
        initialDataFactory: searchOutputFilesBffV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<SearchOutputFilesBffV2MutationResponseApi>,
      [getDeploymentRequestByIdBffV2.name]: {
        relativeUrl: getDeploymentRequestByIdBffV2RelativeUrl,
        initialDataFactory: generateDeploymentRequestResourceItemBffV2,
      } satisfies ApiSdkMockDeclaration<DeploymentRequestResourceItemBffV2Api>,
      [downloadOutputFileForTemplateV2.name]: {
        relativeUrl: downloadOutputFileForTemplateV2RelativeUrl,
        customHandler: downloadOutputFileForTemplateV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<DownloadOutputFileForTemplateV2QueryResponseApi>,
      [downloadOutputFileV2.name]: {
        relativeUrl: downloadOutputFileV2RelativeUrl,
        customHandler: downloadOutputFileV2CustomHandler,
      } satisfies ApiSdkMockDeclaration<DownloadOutputFileV2QueryResponseApi>,
      // Key Set & RKI
      [getKeySetReferenceV2.name]: {
        relativeUrl: getKeySetReferenceV2RelativeUrl,
        initialDataFactory: getKeySetReferenceV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<GetKeySetReferenceV2QueryResponseApi>,
      [getRkiConfigurationByOrganizationIdV2.name]: {
        relativeUrl: getRkiConfigurationByOrganizationIdV2RelativeUrl,
        initialDataFactory: getRkiConfigurationByOrganizationIdV2ResponseMock('GET'),
      } satisfies ApiSdkMockDeclaration<GetRkiConfigurationByOrganizationIdV2QueryResponseApi>,

      [getCatalogShareByIdBffV2.name]: {
        relativeUrl: getCatalogShareByIdBffV2RelativeUrl,
        customHandler: getCatalogShareByIdV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<CatalogShareResourceReadBffApi>,
      [triggerCatalogShareRevokeV2.name]: {
        relativeUrl: triggerCatalogShareRevokeV2RelativeUrl,
        customHandler: triggerCatalogShareRevokeV2ResponseMock,
      } satisfies ApiSdkMockDeclaration<CatalogShareResourceReadApi>,
      [updateResourceByIdV2.name]: {
        relativeUrl: updateResourceByIdV2RelativeUrl,
        customHandler: updateResourceByIdV2Mock,
      } satisfies ApiSdkMockDeclaration<ResourceDataFileResourceReadApi>,
    },
  });
}
